import { IGroupFilterResponse, ILoanListGroupFilterResponse } from '@patient-fi/fed-types';

export function mapFilterConfigurationToLoanFilter(response: IGroupFilterResponse): ILoanListGroupFilterResponse {
  return {
    _id: response._id,
    name: response.name,
    filters: response.filters.map((filter) => ({
      value: undefined,
      filterScheme: filter,
    })),
  };
}
